export function formatDate(dateStr,locale) {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) { 
        return ''
    }
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
        hour12: false
    };
    return date.toLocaleString(locale, options);
}